import React from "react";
import { ArrowLeft } from "lucide-react";
import "./UpsoProgramme.css";
import upsoProgramme from "../../Assets/Images/upso-programme.webp";
import { useNavigate } from "react-router-dom";

function UpsoProgramme() {
  const navigate = useNavigate();

  return (
    <div className="upso-programme-page">
      {/*}
      <button
        className="upso-programme-back-btn"
        onClick={() => navigate(-1)}
      >
        <ArrowLeft size={15} style={{ marginRight: "3px" }} />
        Back to Home
      </button>*/}
      <div className="upso-programme-container">
        <img
          src={upsoProgramme}
          alt="UPSO Programme"
          className="upso-programme-image"
        />
        <div className="upso-text-container">
          <p>
            <i>🎶✨ Program coming soon — stay tuned! ✨🎶</i>
          </p>
        </div>
      </div>
    </div>
  );
}

export default UpsoProgramme;
